import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";

import CreateForm from "./CreateForm";

export default function ModalForm({ showForm, closeForm }) {
  return (
    <>
      <Modal
        className="student inmodal auto without-overflow"
        show={showForm}
        onHide={closeForm}
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Enterprise</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateForm closeForm={closeForm} />
        </Modal.Body>
      </Modal>
    </>
  );
}
